import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export const useUnlinkItemsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.frontend.linkedItem.unlink.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.linkedItem.linkedItems.queryKey(),
        });
      },
    }),
    throwOnError: true,
  });

  const unlinkItems = async (ids: string[]) => {
    await mutation.mutateAsync({ Ids: ids });
  };

  return {
    unlinkItems,
    loading: mutation.isPending,
    error: mutation.error,
  };
};
